import React from 'react'
import './About_content.css'
import Common_title from '../../common_components/common-title/Common_title'
import parse from "html-react-parser"
const About_content = ({data}) => {
  return (
    <>
        <section className='About_content_sec'>
            <div className='container'>
                <Common_title title="ABOUT US" subtitle="Welcome to " logo={process.env.PUBLIC_URL + '/assets/images/header/header_logo2.png'} />

                <div className='row mt-4'>
                    <div className='col-md-7 mx-auto'>
                        <div className='cont_div'>
                            {typeof data?.content === 'string' ? parse(data.content) : null}

                    {/* <p className='founded_p'>Founded in 2024, DPORT has been dedicated to providing the freshest and highest-quality products to our community.</p>

                    <p className='abtcont'>Our mission is to bring you a wide selection of products, from fresh produce. We strive to offer products that are not only good for you but also good for the environment. Our friendly staff is always here to help, ensuring a pleasant and convenient shopping experience for every customer.</p>
                    <p className='abtcont'>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p> */}
                </div>
                    </div>
                </div>
            </div>
        </section>
    </>
  )
}

export default About_content